import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../shared/App.jsx';
import logo from './images/logo.png';
import './index.css';
import './App.css'; // Importar después para sobrescribir variables CSS
import config from './config.js';
import { ConfigProvider } from '../shared/context/ConfigContext.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider value={config}>
      <App logo={logo} />
    </ConfigProvider>
  </React.StrictMode>
);